import { Link } from "react-router-dom";
import { Mail, MessageSquareText, Phone } from "lucide-react";
import { BUSINESS } from "../lib/site";

export const CTA = ({
  headline = "READY TO SELL YOUR ELECTRICAL SURPLUS?",
  sub = `Call ${BUSINESS.manager} at ${BUSINESS.phoneDisplay} — or send photos and get a purchasing offer.`,
}) => (
  <section className="relative overflow-hidden bg-ves-forest" data-testid="cta-section">
    <div className="h-1.5 hazard-stripes" aria-hidden="true" />
    <div className="mx-auto max-w-7xl px-4 py-16 text-center sm:px-6 lg:px-8">
      <h2 className="font-heading text-3xl font-black tracking-tight text-white sm:text-4xl text-balance">
        {headline}
      </h2>
      <p className="mx-auto mt-4 max-w-2xl text-base text-white/80 sm:text-lg">{sub}</p>
      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap">
        <a
          href={BUSINESS.phoneTel}
          className="flex w-full items-center justify-center gap-2 bg-ves-green px-7 py-4 font-heading text-base font-black tracking-wide text-ves-black transition-colors duration-150 hover:bg-white sm:w-auto"
          data-testid="cta-call-button"
        >
          <Phone className="h-5 w-5" /> CALL {BUSINESS.phoneDisplay}
        </a>
        <a
          href={BUSINESS.sms}
          className="flex w-full items-center justify-center gap-2 border-2 border-ves-green px-7 py-4 font-heading text-base font-black tracking-wide text-ves-green transition-colors duration-150 hover:bg-ves-green hover:text-ves-black sm:w-auto"
          data-testid="cta-text-button"
        >
          <MessageSquareText className="h-5 w-5" /> TEXT PHOTOS
        </a>
        <a
          href={BUSINESS.emailHref}
          className="flex w-full items-center justify-center gap-2 border-2 border-white/25 px-7 py-4 font-heading text-base font-black tracking-wide text-white transition-colors duration-150 hover:border-white hover:bg-white hover:text-ves-black sm:w-auto"
          data-testid="cta-email-button"
        >
          <Mail className="h-5 w-5" /> EMAIL US
        </a>
      </div>
      <Link
        to="/sell-your-surplus"
        className="mt-6 inline-block text-sm font-semibold text-white/80 underline decoration-ves-green decoration-2 underline-offset-4 transition-colors duration-150 hover:text-ves-green"
        data-testid="cta-offer-link"
      >
        Prefer a form? Request a purchasing offer →
      </Link>
    </div>
  </section>
);
